import gql from "graphql-tag";

const getUserByID = gql`
  query getUserByID($id: ID!) {
    UserByID: getUserByID(id: $id) {
      id
      roleID
      countryID
      cityID
      extra {
        agencyID
      }
    }
  }
`;

// estado de la firma de los T&C del usuario del token
const getMyTnCStatus = gql`
  query getMyTnCStatus {
    TnCStatus: getMyTnCStatus {
      required
      tncState
      currentVersion
      userVersion
      termsUrl
    }
  }
`;

export { getUserByID, getMyTnCStatus };
